import { type FetchNftMyCollectiblesV2Params, type NFTFormattedCollectibleDTO } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchMyCollectibles } from '../api';

export type UseMyCollectiblesQueryOptions = Omit<
	UseQueryOptions<Array<NFTFormattedCollectibleDTO>, unknown, Array<NFTFormattedCollectibleDTO> | undefined>,
	'queryFn' | 'queryKey' | 'select'
>;

export const useMyCollectiblesQuery = <TData = Array<NFTFormattedCollectibleDTO> | undefined>(
	select: (data: Array<NFTFormattedCollectibleDTO> | undefined) => TData,
	params?: FetchNftMyCollectiblesV2Params & { walletCustody: string },
	options?: UseMyCollectiblesQueryOptions
) =>
	useQuery({
		enabled: !!params?.walletCustody,
		queryFn: () => fetchMyCollectibles(params),
		queryKey: ['myCollectibles', params],
		select,
		...options
	});
